import { FE_LOGGED_OUT_HOMEPAGE_CAMPAIGN_250603 } from "@faire/retailer-settings/FE_LOGGED_OUT_HOMEPAGE_CAMPAIGN_250603";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useAssignSettingLoggedOutHomepageCampaign = () =>
  useAssignSetting(FE_LOGGED_OUT_HOMEPAGE_CAMPAIGN_250603);

export const useSettingLoggedOutHomepageCampaign = () => {
  const setting = useSetting(FE_LOGGED_OUT_HOMEPAGE_CAMPAIGN_250603);
  return setting;
};
